module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8483/img/cta-blobs.png"